import React, {useState} from "react";
import {
    Create,
    Toolbar,
    SimpleForm,
    ReferenceArrayInput,
    CheckboxGroupInput,
    FormDataConsumer
} from 'react-admin';

import "../contract_request/styles/main.css"
import SaveButtonAware from "../component/SaveButtonAware";
import required from "../helper/Required";
import ProvisionCheckboxGroupInput from "../component/ProvisionCheckboxGroupInput";
import {Dialog, DialogActions, DialogContent, DialogContentText, Paper} from "@material-ui/core";
import LoadingComponent from "../component/LoadingComponent";
import ButtonMui from "@material-ui/core/Button";
import errorMessage from "../helper/ErrorMessage";
import medicalPrograms from "../helper/MedicalProgramsAll";
import SignComponent from "../component/SignComponent";
import ContractSelectInput from "../component/ContractSelectInput";

const ProvisionCreate = props => {
    const [alertOpen, setAlertOpen] = useState(false);
    const [alertText, setAlertText] = useState('');
    const [loading, setLoading] = useState(false);
    let keyCallbacks = null;

    const keyMounted = (callbacks) => {
        keyCallbacks = callbacks;
    };

    const popupAlert = (message) => {
        setAlertOpen(true);
        setAlertText(message);
    };

    const handleAlertClose = () => {
        setAlertOpen(false);
    };

    const handleSave = (values, redirect) => {
        setLoading(true);

        if (typeof values.tab ==='undefined' || values.tab === 0) {
            values.signType = 'file';
            processFileKey(values);
        } else if (values.tab === 1) {
            values.signType = 'hardware';
            processHardwareKey(values);
        } else if (values.tab === 2) {
            values.signType = 'gryada';
            processGryadaKey(values);
        }
    };

    const extractProgramIds = (values) => {
        let programIds = [];

        for (let i = 0; i < values.programs.length; i++) {
            for (let j = 0; j < medicalPrograms.length; j++) {
                if (medicalPrograms[j].id !== values.programs[i]) {
                    continue;
                }

                for (let k = 0; k < medicalPrograms[j].list.length; k++) {
                    programIds.push(medicalPrograms[j].list[k].id);
                }
            }
        }

        return programIds;
    };

    const processFileKey = (values) => {
        const reader = new FileReader();
        reader.onloadend = async event => {
            values.keyStore = event.target.result;
            let fileParts = values.sign.title.split('.');
            values.extension = fileParts[fileParts.length - 1];
            values.programs = extractProgramIds(values);

            await sendRequest(values);
        }

        reader.readAsDataURL(values.sign.rawFile);
    };

    const processGryadaKey = (values) => {
        values.programs = extractProgramIds(values);

        sendRequest(values);
    };

    const sendRequest = async (values) => {
        const requestOptions = {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': 'Basic ' + process.env.REACT_APP_API_TOKEN,
                'X-Session': localStorage.getItem('session')
            },
            body: JSON.stringify(values)
        };

        try {
            const response = await fetch(
                process.env.REACT_APP_API_ENTRYPOINT + '/medical_program_provisions',
                requestOptions
            );

            const data = await response.json();

            if (data.success) {
                popupAlert('Запит успішно відправлений.');
            } else {
                errorMessage(data, popupAlert);
            }
            setLoading(false);
        } catch (e) {
            popupAlert('Помилка надсилання запиту');
            setLoading(false);
        }
    };

    const processHardwareKey = (values) => {
        const formData = {
            ca: values.ca,
            signPath: values.signPath,
            password2: values.password2
        };

        keyCallbacks.verify(formData, async (data) => {
            if (!data.keyAgreement?.canBeUsed || !data.signature?.canBeUsed) {
                popupAlert('Помилка зчитування КЕП');
                setLoading(false);
                return;
            }

            values.programs = extractProgramIds(values);

            values.programs.map((item) => {
                let req = {
                    contract_number: values.contractNumber,
                    medical_program_id: item,
                    divisions: values.divisions
                }

                keyCallbacks.sign(
                    JSON.stringify(req),
                    {
                        ca: values.ca,
                        signPath: values.signPath,
                        password2: values.password2
                    },
                    async (signed) => {
                        try {
                            const resp = await fetch(
                                process.env.REACT_APP_BASE_ENTRYPOINT + '/provision/create',
                                {
                                    method: 'POST',
                                    headers: {
                                        'Content-Type': 'application/json',
                                        'Authorization': 'Basic ' + process.env.REACT_APP_API_TOKEN,
                                        'X-Session': localStorage.getItem('session')
                                    },
                                    body: signed.base64Data
                                }
                            );

                            const data = await resp.json();

                            if (data.success) {
                                popupAlert('Запит успішно відправлений.');
                            } else {
                                errorMessage(data, popupAlert);
                            }
                            setLoading(false);
                        } catch (e) {
                            popupAlert('Помилка надсилання запиту');
                            setLoading(false);
                        }
                    }
                );
            });

            // await SignedRequest(
            //     values,
            //     keyCallbacks,
            //     formData,
            //     process.env.REACT_APP_API_ENTRYPOINT + '/contract_requests?onlySerialize=1',
            //     process.env.REACT_APP_BASE_ENTRYPOINT + '/contract_request/save',
            //     popupAlert,
            //     setLoading,
            //     true
            // );
        });
    }

    const ProvisionCreateToolbar = props => (
        <Toolbar {...props}>
            <div className="toolbar-wrapper">
                <div>
                    <SignComponent {...props} onMounted={callbacks => keyMounted(callbacks)} />
                </div>
                <div className="toolbar-button-section">
                    {loading ? <LoadingComponent /> : <SaveButtonAware onSave={handleSave} label="Відправити запит" {...props} />}
                </div>

                <Dialog
                    open={alertOpen}
                    onClose={handleAlertClose}
                    aria-labelledby="alert-dialog-title"
                    aria-describedby="alert-dialog-description"
                >
                    <DialogContent>
                        <DialogContentText id="alert-dialog-content">
                            {alertText}
                        </DialogContentText>
                    </DialogContent>
                    <DialogActions>
                        <ButtonMui onClick={handleAlertClose} color="primary">
                            OK
                        </ButtonMui>
                    </DialogActions>
                </Dialog>
            </div>
        </Toolbar>
    );

    return (
        <Create {...props} title="Створення зобов'язаннь" undoable={false}>
            <SimpleForm toolbar={<ProvisionCreateToolbar {...props} /> }validate={required.validateProvisionCreate}>
                {/*<ReferenceInput*/}
                {/*    formClassName="tab-content-item"*/}
                {/*    label="Номер контракту"*/}
                {/*    source="contractNumber"*/}
                {/*    reference="contracts"*/}
                {/*    validate={required.validateRequired}*/}
                {/*    filter={{ status: 'VERIFIED' }}*/}
                {/*>*/}
                {/*    <SelectInput optionText="contractNumber" optionValue="contractNumber" resettable={true} />*/}
                {/*</ReferenceInput>*/}

                <ContractSelectInput
                    source="contractNumber"
                    label="Номер контракту"
                    optionText="contractNumber"
                    optionValue="contractNumber"
                    validate={required.validateRequired}
                />

                <ReferenceArrayInput
                    formClassName="tab-content-item"
                    label="Аптеки"
                    source="divisions"
                    reference="divisions"
                    validate={required.validateRequired}
                    filter={{ status: 'ACTIVE', dlsVerified: true }}
                    perPage={500}
                >
                    <CheckboxGroupInput />
                </ReferenceArrayInput>

                <FormDataConsumer formClassName="tab-content-item">
                    {({formData, ...rest}) =>
                        (formData.contractNumber ?
                            <ProvisionCheckboxGroupInput {...props} label="Мед. програми" source="programs" row={false} contractNumber={formData.contractNumber} validate={required.validateRequired} />
                            : null)
                    }
                </FormDataConsumer>
            </SimpleForm>
        </Create>
    );
};

export default ProvisionCreate;
